import {
  SmartMeterEligibilityReasonEnum,
  SmEligibilityReasonResponse,
} from "@/api/backofficeRest/generated/model"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ISmartMeterEligibility } from "./smartMeterEligibility.types"
import { SmartMeterEligibility } from "./smartMeterEligibility"

export const SmartMeterEligibilityParser: IParser<
  ISmartMeterEligibility,
  SmEligibilityReasonResponse
> = {
  toDomain: (data: SmEligibilityReasonResponse): ISmartMeterEligibility => {
    try {
      return new SmartMeterEligibility(
        data.reason ?? SmartMeterEligibilityReasonEnum.UNRECOGNIZED,
        data.meterOperatorCode ?? null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
